/**
 * Which of the two work screens a URL lands on, if either — TRBUD-295.
 *
 * `App.tsx` preloads that screen's chunk the moment the entry module runs, in
 * parallel with the session read, so making the queue and the work order lazy
 * does not put a chunk fetch in front of their first paint. See the note above
 * the lazy screens in `App.tsx`.
 *
 * `/` is the queue: `LandingRedirect` sends admins, mechanics and every compact
 * session except a requester or a view-only board there. The other paths are
 * the routes in `App.tsx`; a route renamed without this function would quietly
 * stop being preloaded rather than break, which is why `entry-chunk.test.ts`
 * pins it.
 *
 * Its own module, with no React in it, so the test can import it without
 * evaluating the app.
 *
 * **It must stay SELF-CONTAINED** — no imports, no helpers, nothing outside its
 * own body. `lib/work-screen-preload.ts` serializes it with `toString()` into
 * an inline script in `index.html`, which is how the build preloads the same
 * screen this function names before any module has loaded. A reference to
 * anything outside the function would be undefined there, and
 * `entry-chunk.test.ts` evaluates the serialized copy on its own to catch it.
 */
export function landingScreenFor(pathname: string): "queue" | "work-order" | "report-matrix" | null {
  if (pathname === "/" || pathname === "/work-orders" || pathname === "/work-orders/") return "queue";
  if (pathname.startsWith("/work-orders/")) return "work-order";
  if (pathname.startsWith("/reports/") && pathname !== "/reports/mainx-review") return "report-matrix";
  return null;
}
